module.exports = __webpack_public_path__ + "images/icons/icon-payment-visa-84c7ac09.svg";